/**
 * THROWAWAY DEMO CODE (Pillar procurement demo). Mutable state for the
 * procurement overview: which briefing items were marked done. Resets on page
 * reload or through `resetOverviewDemo()`.
 */
import { createDemoStore } from '@/demo/core/create-demo-store';

export const BRIEFING_ITEM_IDS = [
  'invoices-on-hold',
  'vitrex-escape',
  'rfp-led-highbay',
  'corvane-renewal',
  'stratus-notice',
  'kestrel-onboarding',
  'bom-breaker-risk',
] as const;

export type BriefingItemId = (typeof BRIEFING_ITEM_IDS)[number];

interface OverviewState {
  doneBriefingIds: BriefingItemId[];
}

const store = createDemoStore<OverviewState>(() => ({ doneBriefingIds: [] }));

export function useDoneBriefingIds(): BriefingItemId[] {
  return store.useStore((state) => state.doneBriefingIds);
}

export function setBriefingItemDone(id: BriefingItemId, done: boolean): void {
  store.update((draft) => {
    const without = draft.doneBriefingIds.filter((itemId) => itemId !== id);
    draft.doneBriefingIds = done ? [...without, id] : without;
  });
}

export function resetOverviewDemo(): void {
  store.reset();
}
